export default __webpack_public_path__ + "26841494f22c6a057bda95fba7a744be.png";